module.exports = __webpack_public_path__ + "static/media/manual_placements_place_already_created_sections.62cbf48c.mov";